module.exports = __webpack_public_path__ + "static/media/Call-light.38812d2e.svg";